import React, { Fragment, useState } from "react";
import { Card, Button, Upload, Modal, Input, message, notification } from "antd";
import { DownloadOutlined, DeleteOutlined, EyeOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { getData } from "apiServices/common";
import { IOU_DOCUMENT_GET_ENDPOINT } from "apiServices/API_ENDPOINTS";

// import { FILE_UPLOAD } from "../../Scripts/api";

const { confirm } = Modal;

export default function UploadDocument({
  DOC_ADD = `/api/exim-cost/iou_document/store`,
  filesList,
  setFileList,
  view,
  record,
}) {
  const [loading, setLoading] = useState(false);

  // const base_url = process.env.REACT_APP_BASE;
  const api_base_url = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");
  const props = {
    accept: "image/*",
    showUploadList: false,
    customRequest({ file, onSuccess, onError }) {
      setLoading(true);
      const formData = new FormData();
      formData.append("document", file);
      formData.append("iou_id", record.id);
      formData.append("document_name", file.name);

      fetch(api_base_url + DOC_ADD, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((response) => {
          onSuccess(response, file);
          setLoading(false);
        })
        .catch((err) => {
          onError(err);
          setLoading(false);
        });
    },
    async onChange(info) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done" && info?.file?.response.code == 200) {
        let content = {
          id: info?.file?.response?.data?.id,
          name: info?.file?.response?.data?.document_name,
          path: info?.file?.response?.data?.document,
        };

        setFileList((oldArray) => [...oldArray, content]);

        message.success(`Document uploaded successfully`);
      } else if (info.file.status === "done" && info?.file?.response.code !== 200) {
        message.error(`Document file upload failed.`);
      } else if (info.file.status === "error") {
        message.error(`Document file upload failed.`);
      }
    },
  };

  const removeFile = (index, fileId) => {
    confirm({
      title: "Do you Want to delete these items?",
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      onOk() {
        // let deleteDocument = getData(
        //   `/api/accounting/delete-pi-document/${fileId}`,
        // );
        let items = filesList;
        items.splice(index, 1);
        setFileList([...items]);
      },
      onCancel() {},
    });
  };

  const onChangeHandel = (val, index, context) => {
    filesList[index][context] = val;
    setFileList([...filesList]);
  };

  return (
    <Card className="mt-0 custome-table" title="IOU Document">
      <div className="root-table">
        <table>
          <thead>
            <tr>
              <th className="t-header bc-java">Serial</th>
              <th className="t-header bc-java">Document Name</th>
              <th className="t-header bc-java">File</th>
              <th className="t-header bc-java"></th>
            </tr>
          </thead>
          <tbody>
            {filesList?.length ? (
              <>
                {filesList.map((file, index) => (
                  <Fragment key={index}>
                    <tr>
                      <td className="t-body">{index + 1}</td>
                      <td className="t-body">{file.name}</td>
                      <td className="t-body">
                        <Button type="text" onClick={() => window.open(api_base_url + "/" + file.path, "_blank")}>
                          <EyeOutlined />
                        </Button>
                      </td>
                      {!view && (
                        <td className="t-body">
                          <DeleteOutlined
                            style={{ fontSize: "20px", color: "red" }}
                            className="cursore-pointer"
                            onClick={() => removeFile(index, file.id)}
                          />
                        </td>
                      )}
                    </tr>
                  </Fragment>
                ))}
              </>
            ) : (
              ""
            )}

            <tr>
              <td className="t-body"></td>
              <td className="t-body"></td>
              <td className="t-body"></td>
              <td className="t-body">
                {!view && (
                  <Upload {...props}>
                    <Button type="primary" icon={<DownloadOutlined />} loading={loading}>
                      Upload
                    </Button>
                  </Upload>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}
